<template>
  <b-modal
    id="modalInformacoesGenitor"
    modal-class="modalAddGenitor"
    body-class="modalAddGenitor_body"
    header-class="modalAddGenitor_header"
    centered
    size="xl"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc>
    <template #modal-header>
      <div class="modalGenitor_title w-100">
        Informações de Genitor
      </div>
    </template>
  
    <b-tabs
      end
      class="Genitor-border"
      active-nav-item-class="Genitor--tab-active">
      <b-tab title="Genitor">
        <div class="my-3">
          <b-row>
            <b-col md="2">
              <label class="text-muted mb-1">Tipo filiação</label>
              <div><b>{{ tratarDados('tipoFiliacao', genitor.tipo) }}</b></div>
            </b-col>

            <b-col md="2">
              <label class="text-muted mb-1">CPF</label>
              <div><b>{{ tratarDados('cpf', genitor.cpf) }}</b></div>
            </b-col>

            <b-col md="3">
              <label class="text-muted mb-1">Nome</label>
              <div><b>{{ genitor.nome || 'Não informado' }}</b></div>
            </b-col>

            <b-col md="1">
              <label class="text-muted mb-1">Sexo</label>
              <div><b>{{ tratarDados('sexo', genitor.sexo) }}</b></div>
            </b-col>

            <b-col md="2">
              <label class="text-muted mb-1">Data de nascimento</label>
              <div><b>{{ tratarDados('dataNascimento', genitor.data_nascimento) }}</b></div>
            </b-col>

            <b-col md="2">
              <label class="text-muted mb-1">Profissão</label>
              <div><b>{{ genitor.profissao || 'Não informado' }}</b></div>
            </b-col>
          </b-row>

          <b-row class="mt-4">
            <b-col md="2">
              <label class="text-muted mb-1">Nacionalidade</label>
              <div><b>{{ tratarDados('nacionalidade', genitor.nacionalidade) }}</b></div>
            </b-col>

            <b-col md="2">
              <label class="text-muted mb-1">Naturalidade</label>
              <div><b>{{ genitor.naturalidade || 'Não informado' }}</b></div>
            </b-col>

            <b-col md="1">
              <label class="text-muted mb-1">UF</label>
              <div><b>{{ genitor.naturalidade_uf || 'Não informado' }}</b></div>
            </b-col>

            <b-col md="2">
              <label class="text-muted mb-1">Estado civil</label>
              <div><b>{{ tratarDados('estadoCivil', genitor.estado_civil) }}</b></div>
            </b-col>

            <b-col md="2">
              <label class="text-muted mb-1">Telefone</label>
              <div><b>{{ tratarDados('telefone', genitor.telefone) }}</b></div>
            </b-col>

            <b-col md="3">
              <label class="text-muted mb-1">E-mail</label>
              <div><b>{{ genitor.email || 'Não informado' }}</b></div>
            </b-col>
          </b-row>
        </div>
      </b-tab>

      <b-tab title="Documentos">
        <div class="my-3">
          <b-row>
            <b-col md="2">
              <label class="text-muted mb-1">Documento</label>
              <div><b>{{ genitor.documento_identificacao.tipo || 'Não informado' }}</b></div>
            </b-col>

            <b-col md="2">
              <label class="text-muted mb-1">Número</label>
              <div><b>{{ genitor.documento_identificacao.numero || 'Não informado' }}</b></div>
            </b-col>

            <b-col md="2">
              <label class="text-muted mb-1">Órgão emissor</label>
              <div><b>{{ genitor.documento_identificacao.orgao_emissor || 'Não informado' }}</b></div>
            </b-col>

            <b-col md="2">
              <label class="text-muted mb-1">UF</label>
              <div><b>{{ genitor.documento_identificacao.uf || 'Não informado' }}</b></div>
            </b-col>
          </b-row>
        </div>
      </b-tab>

      <b-tab title="Endereço">
        <div class="my-3">
          <b-row>
            <b-col md="2">
              <label class="text-muted mb-1">CEP</label>
              <div><b>{{ tratarDados('cep', genitor.endereco.cep) }}</b></div>
            </b-col>

            <b-col md="3">
              <label class="text-muted mb-1">Endereço</label>
              <div><b>{{ genitor.endereco.logradouro || 'Não informado' }}</b></div>
            </b-col>

            <b-col md="2">
              <label class="text-muted mb-1">Número</label>
              <div><b>{{ genitor.endereco.numero || 'Não informado' }}</b></div>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="2">
              <label class="text-muted mb-1">Bairro</label>
              <div><b>{{ genitor.endereco.bairro || 'Não informado' }}</b></div>
            </b-col>

            <b-col md="3">
              <label class="text-muted mb-1">Cidade</label>
              <div><b>{{ genitor.endereco.cidade || 'Não informado' }}</b></div>
            </b-col>

            <b-col md="2">
              <label class="text-muted mb-1">UF</label>
              <div><b>{{ genitor.endereco.uf || 'Não informado' }}</b></div>
            </b-col>
          </b-row>
        </div>
      </b-tab>

      <b-tab title="Ascendentes">
        <div class="my-3">
          <b-row
            v-for="(ascendente, index) in genitor.ascendentes || []"
            :key="index">
            <b-col md="2">
              <label class="text-muted mb-1">
                Ascendente - {{ index + 1 }}
              </label>

              <div>
                <b>{{ ascendente.nome || 'Não informado' }}</b>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-tab>
    </b-tabs>

    <div class="d-flex justify-content-end my-3">
      <b-button
        class="btn-voltar px-4"
        @click="$bvModal.hide('modalInformacoesGenitor')">
        Voltar
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  export default {
    name: 'ModalInformacoesGenitor',
    props: {
      genitor: {
        type: Object,
        default: null
      }
    }, 
    methods: {
      tratarDados (tipo, dado) {
        if (!dado) return 'Não informado'

        switch (tipo) {
        case 'tipoFiliacao':
          return this.tratarTipoFiliacao(dado)

        case 'cpf':
          return this.formatarCpf(dado)

        case 'sexo':
          return this.tratarSexo(dado)

        case 'dataNascimento':
          return this.formatarData(dado)

        case 'telefone':
          return this.formatarTelefone(dado)

        case 'nacionalidade':
        case 'estadoCivil':
          return this.formatarTexto(dado)

        case 'cep':
          return this.formatarCep(dado)

        default:
          return dado
        }
      },
      tratarTipoFiliacao (dado) {
        const tipos = {
          Mae: 'Mãe'
        }

        return tipos[dado] || dado
      },
      tratarSexo (dado) {
        const sexos = {
          M: 'Masculino',
          F: 'Feminino'
        }

        return sexos[dado.toUpperCase()] || this.formatarTexto(dado)
      },
      formatarCpf (cpf) {
        cpf = cpf.toString().replace(/\D/g, '')

        if (cpf.length !== 11) return cpf

        return cpf.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          '$1.$2.$3-$4'
        )
      },
      formatarData (data) {
        return data.replace(/-/g, '/')
      },
      formatarTelefone (telefone) {
        telefone = telefone.toString().replace(/\D/g, '')

        if (telefone.length === 11) {
          return telefone.replace(
            /(\d{2})(\d{5})(\d{4})/,
            '($1) $2-$3'
          )
        }

        if (telefone.length === 10) {
          return telefone.replace(
            /(\d{2})(\d{4})(\d{4})/,
            '($1) $2-$3'
          )
        }

        return telefone
      },
      formatarTexto (texto) {
        return texto
          .toLowerCase()
          .replace(/\b\w/g, letra => letra.toUpperCase())
      },
      formatarCep (cep) {
        cep = cep.toString().replace(/\D/g, '')

        if (cep.length !== 8) return cep

        return cep.replace(
          /(\d{5})(\d{3})/,
          '$1-$2'
        )
      }
    }
  }
</script>

<style lang="scss">
  @import '@/scss/_utilities/_exports';

  .modalAddGenitor {
    &_body {
      margin: 0 pxToRem(20);
      padding: 0;
    }

    &_footer {
      border: none;
    }

    &_header{
      padding: 0 0;
    }

    .modal-footer {
      border: none;
    }
  }

  .modalGenitor{
    &_title{
    background-color: #074f7f;
    color: #fff;
    font-size: 1.5rem;
    font-weight: 500;
    padding: 0.625rem 1.25rem;
    }
  }

  .Genitor {
    &--tab-active {
      background-color: $sinoreg-blue !important;
      border: 1px solid $sinoreg-blue !important;
      color: white !important;
      font-weight: bold;
    }

    &-border ul.nav {
      border-bottom: 3px solid $sinoreg-blue !important;
    }

    &-border ul.nav > li.nav-item > a {
      border: 1px solid #696969;
      border-bottom: 0;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      color: black;
      font-size: pxToRem(15);
    }

    &-border ul.nav > li.nav-item > a:hover {
      border: 1px solid #696969;
      border-bottom: 0;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
  }

  .btn-voltar {
    background-color: #C6C6C6;
    border-color: #C6C6C6;
    color: #000;

    &:hover,
    &:focus,
    &:active {
      background-color: #b5b5b5 !important;
      border-color: #b5b5b5 !important;
      color: #000;
    }
  }
</style>